import './media-selector.scss';

import { loadYoutubeApi } from '../../utilities/js/helper';

class MediaSelector {
    constructor (element) {
        this.$media = element;
        this.mediaType = this.$media.getAttribute('data-media');
        this.$mediaPlayCTA = this.$media.querySelector('[data-media="play"]');
        this.$video = null;
        this.$$youtubeTNSrcSet = [];
        this.$$youtubeTNSrc = [];
    }

    initialize () {
        if (this.mediaType === 'youtube') {
            this.$video = this.$media.querySelector('[data-youtube]');

            if (this.$mediaPlayCTA) {
                this.$mediaPlayCTA.removeAttribute('disabled');
            }

            // replace placeholder image with real thumbnail src
            this.$$youtubeTNSrcSet = this.$media.querySelectorAll('[data-youtube-tn-srcset]');
            this.$$youtubeTNSrc = this.$media.querySelectorAll('[data-youtube-tn-src]');

            this.$$youtubeTNSrcSet.forEach($youtubeTNSrcSet => {
                $youtubeTNSrcSet.setAttribute('srcset', $youtubeTNSrcSet.dataset.youtubeTnSrcset);
            });

            this.$$youtubeTNSrc.forEach($youtubeTNSrc => {
                $youtubeTNSrc.setAttribute('srcset', $youtubeTNSrc.dataset.youtubeTnSrc);
            });

            import('../../utilities/js/youtube-player').then(({ YoutubePlayer }) => {
                this.initYoutubePlayer(YoutubePlayer);
            });
        }

        if (this.mediaType === 'video') {
            this.$video = this.$media.querySelector('video');
            this.initHTML5Player();
        }
    }

    initYoutubePlayer (YoutubePlayer) {
        if (this.$video) {
            const youtubeId = this.$video.getAttribute('data-youtube');
            let buttonActiveState = true;

            if (youtubeId !== '') {
                const videoPlayer = new YoutubePlayer(this.$video, {
                    silent: !!this.$video.getAttribute('data-muted'),
                    fullscreen: !!this.$video.getAttribute('data-fullscreen'),
                    loop: !!this.$video.getAttribute('data-loop'),
                    root: this.$media,
                    id: youtubeId,
                    observe: true,
                    onCall: () => {
                        this.$media.classList.add('is--shown');
                    },
                    onStart: (videoId) => {
                        this.$media.classList.add('is--shown');
                    },
                    onEnd: (videoId) => {
                        if (videoPlayer.player.video.isMuted() === false) {
                            videoPlayer.destroy();
                            this.$media.classList.remove('is--shown');
                            buttonActiveState = true;
                        }
                    },
                    onPause: (videoId, progress) => {
                        console.log('video pause');
                    }
                });

                this.$mediaPlayCTA.onclick = () => {
                    if (buttonActiveState === true) {
                        buttonActiveState = false;

                        const interval = setInterval(() => {
                            const $iframe = this.$video.parentElement.querySelector('iframe');
                            if ($iframe) {
                                $iframe.setAttribute('tabindex', '0');
                                $iframe.focus();
                                clearInterval(interval);
                            }
                        }, 100);
                    }
                };
            }
        }
    }

    playVideo () {
        this.$media.classList.add('is--playing');
        this.$video.play();
        this.$video.setAttribute('controls', 'true'); // Zeige Bedienelemente an
    }

    pauseVideo () {
        this.$media.classList.remove('is--playing');
        this.$video.pause();
        this.$video.removeAttribute('controls'); // Verstecke Bedienelemente
    }

    initHTML5Player () {
        const autoplay = !!this.$video.getAttribute('autoplay');
        const loop = !!this.$video.getAttribute('loop');

        if (autoplay) {
            this.$media.classList.add('is--playing');
            this.$video.load();
        }

        if (!loop) {
            this.$video.addEventListener('ended', () => {
                this.$media.classList.remove('is--playing');
            });
        }

        if (this.$mediaPlayCTA) {
            this.$mediaPlayCTA.onclick = () => {
                if (this.$video.paused) {
                    this.playVideo();
                } else {
                    this.pauseVideo();
                }
            };
        }

        this.$video.addEventListener('click', () => {
            if (!this.$video.paused) {
                this.playVideo();
            }
        });

        this.$video.addEventListener('keydown', (e) => {
            if (e.code === 'Space') {
                e.preventDefault();
                this.playVideo();
            }
        });
    }
}

export { MediaSelector };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$media = $context.querySelectorAll('[data-media]');

        if ($$media.length > 0) {
            window.addEventListener('check.cookie_consent', (e) => {
                if (e.detail.consentCategory === 's30' && e.detail.consentStatus === true) {
                    loadYoutubeApi();

                    window.onYouTubeIframeAPIReady = () => {
                        $$media.forEach((media) => {
                            const $media = new MediaSelector(media);
                            $media.initialize();
                        });
                    };
                }
            });
        }
    }
});
